// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hwllhTdyIwI3o9PBbjnw {
    margin-left: 40px
}
.Xfh8sMpTLuJUpGHxu2eN {
    font-family: Noto Sans;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 700;
    font-weight: 17px
}
.ejT57AJSy9fFzosAqXFp {
    margin-top: 43px
}
.Wlzkhl2S31cgLhfSxaTM {
    height: 50px;
    width: 316px;
    border-radius: 5px !important
}
.XoZNDP4mUlWscuyc1gFw {
    height: 38px;
    width: 120px;
    --tw-bg-opacity: 1;
    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
.XoZNDP4mUlWscuyc1gFw:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
.OuoPi0IqcDWZ2d8lLvNv {
    margin-top: 80px;
    justify-content: flex-end
}
.wFvgB9KCOlz0aSGuZZKi {
    margin-right: 20px;
    display: flex;
    justify-content: flex-end
}

.ejT57AJSy9fFzosAqXFp .ant-form-item-label > label {
    --tw-text-opacity: 1;
    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}
.nllEOjew1wDtI_k6R7yA {
    display: flex;
    justify-content: center
}
.ipAyR5A26kU7ZphH5brI {
    width: 100%;
    max-width: 28rem
}
`, "",{"version":3,"sources":["webpack://./src/components/Account/ChangePassword/ChangePassword.module.css"],"names":[],"mappings":"AACE;IAAA;AAAgB;AAGhB;IAAA,sBAA+C;IAA/C,mBAA+C;IAA/C,oBAA+C;IAA/C,gBAA+C;IAA/C;AAA+C;AAG/C;IAAA;AAAgB;AAGhB;IAAA,YAAwC;IAAxC,YAAwC;IAAxC;AAAwC;AAGxC;IAAA,YAAiD;IAAjD,YAAiD;IAAjD,kBAAiD;IAAjD,0DAAiD;IAAjD,oBAAiD;IAAjD;AAAiD;AAGjD;IAAA,6BAAgC;IAAhC,qEAAgC;IAAhC,+BAAgC;IAAhC;AAAgC;AAGhC;IAAA,gBAA4B;IAA5B;AAA4B;AAG5B;IAAA,kBAAiC;IAAjC,aAAiC;IAAjC;AAAiC;;AAIjC;IAAA,oBAAoB;IAApB;AAAoB;AAGpB;IAAA,aAA0B;IAA1B;AAA0B;AAG1B;IAAA,WAAsB;IAAtB;AAAsB","sourcesContent":[".container {\n  @apply ml-[40px];\n}\n.title {\n  @apply text-lg font-bold font-inter font-[17px];\n}\n.formStyle {\n  @apply mt-[43px];\n}\n.customInput {\n  @apply h-[50px] w-[316px] !rounded-[5px];\n}\n.applyButton {\n  @apply bg-secondary text-white w-[120px] h-[38px];\n}\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n.buttons {\n  @apply justify-end mt-[80px];\n}\n.applyButtonGroup {\n  @apply flex justify-end mr-[20px];\n}\n\n.formStyle :global(.ant-form-item-label > label) {\n  @apply text-gray-600;\n}\n.formWrapper {\n  @apply flex justify-center;\n}\n.onlyItems {\n  @apply w-full max-w-md;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hwllhTdyIwI3o9PBbjnw`,
	"title": `Xfh8sMpTLuJUpGHxu2eN`,
	"formStyle": `ejT57AJSy9fFzosAqXFp`,
	"customInput": `Wlzkhl2S31cgLhfSxaTM`,
	"applyButton": `XoZNDP4mUlWscuyc1gFw`,
	"buttons": `OuoPi0IqcDWZ2d8lLvNv`,
	"applyButtonGroup": `wFvgB9KCOlz0aSGuZZKi`,
	"formWrapper": `nllEOjew1wDtI_k6R7yA`,
	"onlyItems": `ipAyR5A26kU7ZphH5brI`
};
export default ___CSS_LOADER_EXPORT___;
